export function parse(query = "") {
  return Object.fromEntries(new URLSearchParams(query));
}
